import React, { useState, useEffect, useContext } from 'react';
import handleSubmitForCheckbox from "../../Controller/AssignFormController/AssignFormController";
import FormService from "../../../Setup/controller/FormController/FormController";
import { Link } from "react-router-dom";
import { useNavigate } from 'react-router-dom';
import { ThemeContext } from "../../../Layout/Theme/ThemeContext";

import FormPermissionService from "../../../Setup/controller/FormPermissionController/FormPermissionController";
function FormListPage() {
    const navigate = useNavigate();

    const redirectCallback = () => {
        navigate('/'); // Redirect to the login page
    };
    const RoleID = localStorage.getItem('RoleID');
    const FormAction = "/AssignForms";
    FormPermissionService.HasPerimssion(redirectCallback, RoleID, FormAction);

    const [formList, setForms] = useState([]);
    const [AssignedformList, setAssignedForms] = useState([]);
    const { theme, toggleTheme } = useContext(ThemeContext);
    let accordTheme = "accordion-header-light";
    if (theme == "dark") {
        accordTheme = "accordion-header-dark";
    }

    const getParamsFromQueryString = () => {
        const searchParams = new URLSearchParams(window.location.search);
        const params = {};
        for (const [key, value] of searchParams.entries()) {
            params[key] = value;
        }
        return params;
    };

    const params = getParamsFromQueryString();
    const ClientID = params['ClientID'];
    const ModuleID = params['ModuleID'];


    useEffect(() => {
        async function fetchModules() {
            try {
                debugger;
                const redirectCallback = () => {
                    navigate('/'); // Redirect to the login page
                };

                const formData = await FormService.GetClientAssignedForms(redirectCallback, ClientID, ModuleID);

                setForms(formData[0]);
            } catch (error) {
                console.error('Error fetching Modules:', error);
            }
        }
        fetchModules();
    }, []);

    return (
        <div>
            <div className="main-content-header">
                <h1>Assign Forms</h1>
            </div>
            <div className="row">
                <div className="col-xl-12">
                    <div className="card mb-30">
                        <div className="card-body">
                            <table className="table datatable table-bordered">
                                <thead>
                                    <tr>
                                        <th>Form Name</th>

                                    </tr>
                                </thead><tbody>

                                    {
                                        formList.map(form => (
                                            <tr>
                                                <td>{form.FormName}</td>

                                            </tr>
                                        ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div >
    );
}

export default FormListPage;
